import type { BadgeColor } from '$lib/components/atoms/badge/types';
import type { IconName } from '$lib/components/icons/types';
import type { TrafficInformationEventType, TrafficScheme } from './types';

export const mapTrafficEventTypeToScheme: Record<TrafficInformationEventType, TrafficScheme> = {
	ACCIDENT: 'carAccident',
	INCIDENT: 'carIncident',
	ROAD_CLOSED: 'laneClosed',
	ROAD_WORKS: 'constructionCone',
	SHRINKING: 'carDangerous',
	WEATHER: 'weatherHail',
};

export const mapTrafficSchemeToIcon: Record<TrafficScheme, IconName> = {
	carAccident: 'car-accident',
	carIncident: 'car-incident',
	carDangerous: 'car-dangerous',
	laneClosed: 'lane-closed',
	constructionCone: 'construction-cone',
	weatherHail: 'weather-hail',
};

export const mapTrafficSchemeToColor: Record<TrafficScheme, BadgeColor> = {
	carAccident: 'error',
	carIncident: 'error',
	carDangerous: 'warning',
	laneClosed: 'warning',
	constructionCone: 'car',
	weatherHail: 'car',
};
